( function( $ ) {
  if ( $( '.__gallery_grid' ).length > 0  ) {
    $( '.__slider_grid' ).slick( {
      slidesToShow   : 1,
      slidesToScroll : 1,
      dots           : true,
      fade           : true,
      arrows         : false,
    } );

    $( window ).on( 'resize', function() {
      $( '.lb-close' ).trigger( 'click' );
    } );

    lightbox.option( {
      'disableScrolling': true,
      'wrapAround'      : true
    } );

    if ( $( '.slick-dots li' ).length < 2 )
      $( '.__slider_grid' ).addClass( '__single_slide' )
  }
} ) ( jQuery );